import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CSVIcon } from '../../../../../assets/images/csv.svg';
import FileUpload from '../../../../../components/shared/FileUpload/FileUpload';

import styles from './SelectFile.module.scss';

const SelectFile = ({ acceptedFiles, handleFileDelete, handleOnDrop, TEMPLATE_URL }) => {
  const { t } = useTranslation('common');
  return (
    <>
      <p className={styles.heading}>{t('csvImport.importYourFile')}</p>
      <p className={styles.text}>{t('csvImport.dragAndDrop')}</p>
      <a className={styles.downloadLink} href={TEMPLATE_URL} download>
        {t('csvImport.downloadTemplate')}
      </a>
      <FileUpload
        acceptedFiles={acceptedFiles}
        handleFileDelete={handleFileDelete}
        handleOnDrop={handleOnDrop}
        accept={{ 'text/csv': ['.csv', '.vcf'] }}
        DropzoneIcon={CSVIcon}
      />
    </>
  );
};

export default SelectFile;
